import { CpPersonInterface } from '../../../interfaces/dto/person/cp-person-interface';

export class CpPersonModel implements CpPersonInterface {
  Address: string = '';
  Birthdate: string = '';
  City: string = '';
  Email: string = '';
  FiscalNumber: string = '';
  FiscalNumberCountryCode: string = '';
  Gender: string = '';
  Iban: string = '';
  Mobile: string = '';
  Name: string = '';
  NationalCardNumber: string = '';
  NationalCardNumberCountryCode: string = '';
  PostalCode: string = '';

  constructor(init?: Partial<CpPersonModel>) {
    Object.assign(this, init);
  }
}
